"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InspectionControllerGetInspectionsForAdminV1StatusEnum = exports.InspectionControllerGetAllInspectionsV1InspectionTypeEnum = exports.InspectionApi = void 0;
var runtime = __importStar(require("../runtime"));
var index_1 = require("../models/index");
/**
 *
 */
var InspectionApi = /** @class */ (function (_super) {
    __extends(InspectionApi, _super);
    function InspectionApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Adds notes to an existing inspection. Only admin users, property owners, or agents associated with the listing can add notes.
     * Add notes to an inspection
     */
    InspectionApi.prototype.inspectionControllerAddNotesForInspectionV1Raw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, urlPath, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters['id'] == null) {
                            throw new runtime.RequiredError('id', 'Required parameter "id" was null or undefined when calling inspectionControllerAddNotesForInspectionV1().');
                        }
                        if (requestParameters['addNotesForInspectionDto'] == null) {
                            throw new runtime.RequiredError('addNotesForInspectionDto', 'Required parameter "addNotesForInspectionDto" was null or undefined when calling inspectionControllerAddNotesForInspectionV1().');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2:
                        urlPath = "/v1/inspections/{id}/notes";
                        urlPath = urlPath.replace("{".concat("id", "}"), encodeURIComponent(String(requestParameters['id'])));
                        return [4 /*yield*/, this.request({
                                path: urlPath,
                                method: 'PUT',
                                headers: headerParameters,
                                query: queryParameters,
                                body: (0, index_1.AddNotesForInspectionDtoToJSON)(requestParameters['addNotesForInspectionDto']),
                            }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.InspectionItemResponseDtoFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Adds notes to an existing inspection. Only admin users, property owners, or agents associated with the listing can add notes.
     * Add notes to an inspection
     */
    InspectionApi.prototype.inspectionControllerAddNotesForInspectionV1 = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.inspectionControllerAddNotesForInspectionV1Raw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Adds a walk-in inspection for a listing. Only admin users, property owners, or agents associated with the listing can add walk-in inspections.
     * Add a walk-in inspection
     */
    InspectionApi.prototype.inspectionControllerAddWalkinInspectionV1Raw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, urlPath, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters['addWalkinInspectionDto'] == null) {
                            throw new runtime.RequiredError('addWalkinInspectionDto', 'Required parameter "addWalkinInspectionDto" was null or undefined when calling inspectionControllerAddWalkinInspectionV1().');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2:
                        urlPath = "/v1/inspections/walkin";
                        return [4 /*yield*/, this.request({
                                path: urlPath,
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                                body: (0, index_1.AddWalkinInspectionDtoToJSON)(requestParameters['addWalkinInspectionDto']),
                            }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.InspectionItemResponseDtoFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Adds a walk-in inspection for a listing. Only admin users, property owners, or agents associated with the listing can add walk-in inspections.
     * Add a walk-in inspection
     */
    InspectionApi.prototype.inspectionControllerAddWalkinInspectionV1 = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.inspectionControllerAddWalkinInspectionV1Raw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Books an inspection for a listing. For OPEN inspections, a listingInspectionId is required. For PRIVATE inspections, inspectionStartTime and inspectionEndTime are required. The enquiry will be routed to the appropriate receiver (agent or property owner) based on the listing configuration. Does not require authentication - guests can book by providing their email, name and phone number.
     * Book an inspection
     */
    InspectionApi.prototype.inspectionControllerBookInspectionV1Raw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, urlPath, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters['bookInspectionDto'] == null) {
                            throw new runtime.RequiredError('bookInspectionDto', 'Required parameter "bookInspectionDto" was null or undefined when calling inspectionControllerBookInspectionV1().');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2:
                        urlPath = "/v1/inspections";
                        return [4 /*yield*/, this.request({
                                path: urlPath,
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                                body: (0, index_1.BookInspectionDtoToJSON)(requestParameters['bookInspectionDto']),
                            }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.BookInspectionEnquiryApiResponseDtoFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Books an inspection for a listing. For OPEN inspections, a listingInspectionId is required. For PRIVATE inspections, inspectionStartTime and inspectionEndTime are required. The enquiry will be routed to the appropriate receiver (agent or property owner) based on the listing configuration. Does not require authentication - guests can book by providing their email, name and phone number.
     * Book an inspection
     */
    InspectionApi.prototype.inspectionControllerBookInspectionV1 = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.inspectionControllerBookInspectionV1Raw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Creates an open inspection for a listing. Only admin users, property owners, or agents associated with the listing can create open inspections.
     * Create an open inspection
     */
    InspectionApi.prototype.inspectionControllerCreateOpenInspectionV1Raw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, urlPath, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters['createInspectionDto'] == null) {
                            throw new runtime.RequiredError('createInspectionDto', 'Required parameter "createInspectionDto" was null or undefined when calling inspectionControllerCreateOpenInspectionV1().');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2:
                        urlPath = "/v1/inspections/open";
                        return [4 /*yield*/, this.request({
                                path: urlPath,
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                                body: (0, index_1.CreateInspectionDtoToJSON)(requestParameters['createInspectionDto']),
                            }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.CreateOpenInspectionApiResponseDtoFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Creates an open inspection for a listing. Only admin users, property owners, or agents associated with the listing can create open inspections.
     * Create an open inspection
     */
    InspectionApi.prototype.inspectionControllerCreateOpenInspectionV1 = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.inspectionControllerCreateOpenInspectionV1Raw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Gets all inspections for a listing (open inspections and approved private inspections). Only admin users, property owners, or agents associated with the listing can access this endpoint.
     * Get all listing inspections
     */
    InspectionApi.prototype.inspectionControllerGetAllInspectionsV1Raw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, urlPath, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters['listingId'] == null) {
                            throw new runtime.RequiredError('listingId', 'Required parameter "listingId" was null or undefined when calling inspectionControllerGetAllInspectionsV1().');
                        }
                        queryParameters = {};
                        if (requestParameters['pageNo'] != null) {
                            queryParameters['pageNo'] = requestParameters['pageNo'];
                        }
                        if (requestParameters['pageSize'] != null) {
                            queryParameters['pageSize'] = requestParameters['pageSize'];
                        }
                        if (requestParameters['startTime'] != null) {
                            queryParameters['startTime'] = requestParameters['startTime'];
                        }
                        if (requestParameters['endTime'] != null) {
                            queryParameters['endTime'] = requestParameters['endTime'];
                        }
                        if (requestParameters['inspectionType'] != null) {
                            queryParameters['inspectionType'] = requestParameters['inspectionType'];
                        }
                        if (requestParameters['showCancelledInspections'] != null) {
                            queryParameters['showCancelledInspections'] = requestParameters['showCancelledInspections'];
                        }
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2:
                        urlPath = "/v1/inspections/all/listings/{listingId}";
                        urlPath = urlPath.replace("{".concat("listingId", "}"), encodeURIComponent(String(requestParameters['listingId'])));
                        return [4 /*yield*/, this.request({
                                path: urlPath,
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.GetAllInspectionsApiResponseDtoFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Gets all inspections for a listing (open inspections and approved private inspections). Only admin users, property owners, or agents associated with the listing can access this endpoint.
     * Get all listing inspections
     */
    InspectionApi.prototype.inspectionControllerGetAllInspectionsV1 = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.inspectionControllerGetAllInspectionsV1Raw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Gets a list of inspections for a listing. Only admin users or vendors can access this endpoint.
     * Get inspections for admin/vendor
     */
    InspectionApi.prototype.inspectionControllerGetInspectionsForAdminV1Raw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, urlPath, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters['listingId'] == null) {
                            throw new runtime.RequiredError('listingId', 'Required parameter "listingId" was null or undefined when calling inspectionControllerGetInspectionsForAdminV1().');
                        }
                        queryParameters = {};
                        if (requestParameters['pageNo'] != null) {
                            queryParameters['pageNo'] = requestParameters['pageNo'];
                        }
                        if (requestParameters['pageSize'] != null) {
                            queryParameters['pageSize'] = requestParameters['pageSize'];
                        }
                        if (requestParameters['startTime'] != null) {
                            queryParameters['startTime'] = requestParameters['startTime'];
                        }
                        if (requestParameters['endTime'] != null) {
                            queryParameters['endTime'] = requestParameters['endTime'];
                        }
                        if (requestParameters['status'] != null) {
                            queryParameters['status'] = requestParameters['status'];
                        }
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2:
                        urlPath = "/v1/inspections/listings/{listingId}";
                        urlPath = urlPath.replace("{".concat("listingId", "}"), encodeURIComponent(String(requestParameters['listingId'])));
                        return [4 /*yield*/, this.request({
                                path: urlPath,
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.GetInspectionsApiResponseDtoFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Gets a list of inspections for a listing. Only admin users or vendors can access this endpoint.
     * Get inspections for admin/vendor
     */
    InspectionApi.prototype.inspectionControllerGetInspectionsForAdminV1 = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.inspectionControllerGetInspectionsForAdminV1Raw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Updates the attendance status of an existing inspection. Only admin users, property owners, or agents associated with the listing can update attendance status.
     * Update attendance status for an inspection
     */
    InspectionApi.prototype.inspectionControllerUpdateAttendanceStatusForInspectionV1Raw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, urlPath, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters['id'] == null) {
                            throw new runtime.RequiredError('id', 'Required parameter "id" was null or undefined when calling inspectionControllerUpdateAttendanceStatusForInspectionV1().');
                        }
                        if (requestParameters['updateAttendanceStatusDto'] == null) {
                            throw new runtime.RequiredError('updateAttendanceStatusDto', 'Required parameter "updateAttendanceStatusDto" was null or undefined when calling inspectionControllerUpdateAttendanceStatusForInspectionV1().');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2:
                        urlPath = "/v1/inspections/{id}/attendance-status";
                        urlPath = urlPath.replace("{".concat("id", "}"), encodeURIComponent(String(requestParameters['id'])));
                        return [4 /*yield*/, this.request({
                                path: urlPath,
                                method: 'PUT',
                                headers: headerParameters,
                                query: queryParameters,
                                body: (0, index_1.UpdateAttendanceStatusDtoToJSON)(requestParameters['updateAttendanceStatusDto']),
                            }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.InspectionItemResponseDtoFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Updates the attendance status of an existing inspection. Only admin users, property owners, or agents associated with the listing can update attendance status.
     * Update attendance status for an inspection
     */
    InspectionApi.prototype.inspectionControllerUpdateAttendanceStatusForInspectionV1 = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.inspectionControllerUpdateAttendanceStatusForInspectionV1Raw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * For update, the current open inspection will be cancelled and a new one will be created. For cancel, only the current inspection is cancelled.
     * Update or cancel an open inspection
     */
    InspectionApi.prototype.inspectionControllerUpdateOrCancelOpenInspectionV1Raw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, urlPath, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters['id'] == null) {
                            throw new runtime.RequiredError('id', 'Required parameter "id" was null or undefined when calling inspectionControllerUpdateOrCancelOpenInspectionV1().');
                        }
                        if (requestParameters['updateOrCancelOpenInspectionDto'] == null) {
                            throw new runtime.RequiredError('updateOrCancelOpenInspectionDto', 'Required parameter "updateOrCancelOpenInspectionDto" was null or undefined when calling inspectionControllerUpdateOrCancelOpenInspectionV1().');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2:
                        urlPath = "/v1/inspections/{id}";
                        urlPath = urlPath.replace("{".concat("id", "}"), encodeURIComponent(String(requestParameters['id'])));
                        return [4 /*yield*/, this.request({
                                path: urlPath,
                                method: 'PATCH',
                                headers: headerParameters,
                                query: queryParameters,
                                body: (0, index_1.UpdateOrCancelOpenInspectionDtoToJSON)(requestParameters['updateOrCancelOpenInspectionDto']),
                            }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.OpenInspectionApiResponseDtoFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * For update, the current open inspection will be cancelled and a new one will be created. For cancel, only the current inspection is cancelled.
     * Update or cancel an open inspection
     */
    InspectionApi.prototype.inspectionControllerUpdateOrCancelOpenInspectionV1 = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.inspectionControllerUpdateOrCancelOpenInspectionV1Raw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    return InspectionApi;
}(runtime.BaseAPI));
exports.InspectionApi = InspectionApi;
/**
 * @export
 */
exports.InspectionControllerGetAllInspectionsV1InspectionTypeEnum = {
    Private: 'private',
    Open: 'open'
};
/**
 * @export
 */
exports.InspectionControllerGetInspectionsForAdminV1StatusEnum = {
    Pending: 'pending',
    Attended: 'attended',
    Unattended: 'unattended'
};
